import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        question: '='
    },
    template: `
        <a class="btn main small" ng-click="vm.manageLanguages(vm.question, vm.form)">{{ 'general.Manage translations' | translate }}</a>
    `
})
export default class {
    constructor ($rootScope, $scope, ModalService, QuestionCategoryResource) {
        this.ModalService = ModalService;
        this.QuestionCategoryResource = QuestionCategoryResource;
        const listener = $rootScope.$on('question:reload', (event, updatedModel) => {
            this.form.saved = true;
            this.form.model = updatedModel;
            this.question = updatedModel;
        });
        $scope.$on('$destroy', listener);
    }

    manageLanguages (question, form) {
        return this.ModalService.open({
            animation: true,
            template: `
                <modals-question-translation
                    update="vm.update()"
                    update-form="vm.form"
                    question="vm.question"
                    cancel="vm.$uibModalInstance.dismiss()"
                    class="wrapper"></modals-question-translation>
                `,
            size: 'full',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.question = question;
                this.form = form;

                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/translation/index.js